// extracted by mini-css-extract-plugin
module.exports = {"DeleteBtnContainer":"Ciiu-1PEbCpfLU4RNhaUU"};